module.exports = __webpack_public_path__ + "e2330abbdacd0fa2a0827437bb901a36.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/stryker_2021_chart.png
// module id = 1731
// module chunks = 0